import React, { useState } from 'react';
import { IconButton, Menu, MenuItem, ListItemText, ListItemIcon } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import CheckIcon from '@mui/icons-material/Check';
import { useTranslation } from 'react-i18next';
import { LANGS, changeLanguage } from '../i18n';

// Перемикач мови — у хедері, доступний на будь-якій сторінці.
// color='inherit' щоб коректно виглядати і в темному AppBar, і у світлому меню.
export default function LanguageSwitcher({ color = 'inherit' }) {
  const { i18n } = useTranslation();
  const [anchor, setAnchor] = useState(null);
  const current = i18n.language;

  const open = (e) => setAnchor(e.currentTarget);
  const close = () => setAnchor(null);
  const pick = (code) => { changeLanguage(code); close(); };

  return (
    <>
      <IconButton color={color} onClick={open} aria-label="Language" size="small">
        <LanguageIcon />
      </IconButton>
      <Menu anchorEl={anchor} open={!!anchor} onClose={close}>
        {LANGS.map((l) => (
          <MenuItem key={l.code} selected={l.code === current} onClick={() => pick(l.code)}>
            <ListItemIcon sx={{ minWidth: 32 }}>
              {l.code === current ? <CheckIcon fontSize="small" /> : null}
            </ListItemIcon>
            <ListItemText>{l.label}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
